$(function() {

    const successModal = $('#careers-apply-modal-success');
    successModal.find('#careers-apply-modal-success-button').on('click', function() {
        successModal.hide();
    });

    const errorModal = $('#careers-apply-modal-error');
    errorModal.find('#careers-apply-modal-error-button').on('click', function() {
        errorModal.hide();
    });

    $('#careers-page .apply-button').on('click', function(e) {
        const button = $(e.target);

        const modal = $('#careers-apply-modal');

        modal.find('#careers-apply-modal-close').on('click', function() {
            modal.modal('toggle');
            grecaptcha.reset(careersRecaptcha);
        });

        let title = button.data('title');
        let location = button.data('location');

        // Set the modal title
        modal.find('#apply-modal-title').text((title === undefined) ? 'Upload Resume' : `Apply to ${title}`);

        // Set the modal job & location field
        if(title !== undefined && location !== undefined) {
            modal.find('#apply-position-input').val(title + ' - ' + location);
        } else {
            modal.find('#apply-position-input').val(null);
        }

        const form = modal.find('#careers-apply-form');
        const submitButton = modal.find('#apply-submit-button');
        const route = form.data('action');
        form.on('submit', function(event) {
            event.preventDefault();
            event.stopPropagation();

            submitButton.attr('disabled', true);

            const formData = new FormData();
            const fields = form.find('input,select');
            for(let field of fields) {
                form.find(`#apply-${field.name}-input-error`).text('');
                if(field.type !== 'file') {
                    if($(field).val() !== null) {
                        formData.append(field.name, $(field).val());
                    }
                } else {
                    formData.append(field.name, $(field)[0].files[0]);
                }
            }

            formData.append('recaptcha', grecaptcha.getResponse(careersRecaptcha));

            $.ajax({
                url: route,
                method: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                headers: {
                    'X-CSRF-TOKEN': formData.get('_token')
                },
                success: function() {
                    for(let field of fields) {
                        $(field).val(null);
                    }
                    
                    modal.modal('toggle');
                    successModal.show();
                },
                error: function(response) {
                    if(response.status === 422) {
                        for(let field in response.responseJSON) {
                            form.find(`#apply-${field}-input-error`).text(response.responseJSON[field][0]);
                        }
                    } else {
                        $('#careers-apply-modal-error').show();
                    }
                },
                complete: function() {
                    submitButton.attr('disabled', false);
                    grecaptcha.reset(careersRecaptcha);
                }
            });
        });

        modal.modal('toggle');
    });
});